'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialTiktokWhiteAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.4168 2H12.964V15.6232C12.964 17.2464 11.6361 18.5797 9.98344 18.5797C8.33082 18.5797 7.00283 17.2464 7.00283 15.6232C7.00283 14.029 8.30132 12.7246 9.89493 12.6667V9.24639C6.3831 9.30433 3.55005 12.1159 3.55005 15.6232C3.55005 19.1594 6.44212 22 10.013 22C13.5838 22 16.4758 19.1304 16.4758 15.6232V8.63767C17.7743 9.56522 19.3679 10.1159 21.05 10.1449V6.72464C18.4531 6.63768 16.4168 4.55072 16.4168 2Z",
        fill: "white"
      }
    )
  }
);
const VpSocialTiktokWhiteAsset = forwardRef(SocialTiktokWhiteAsset);

export { VpSocialTiktokWhiteAsset as default };
